export default "__VITE_ASSET__D4is3Cyo__"